import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { UserPortalContext } from '../../../context/appcontext';
import {
	getItemRetailOnHandInventory,
	getItemUnitOnHandInventory,
} from '../../../redux/actions/itemDrillDownActions';
import { DrillDownTrend } from '../Common';

function ItemOnHandInventory({
	chartName,
	weekFilter,
	category,
	selectedFilter,
	startDate,
	endDate,
	selectedTab,
	itemNum,
}) {
	const dispatch = useDispatch();
	const portalUserContext = React.useContext(UserPortalContext);
	const { itemRetailOnHandInventory, itemUnitOnHandInventory } = useSelector(
		(state) => state.itemDrillDownReducer
	);
	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	React.useEffect(() => {
		const params = {
			categoryId: '-1',
			period: weekFilter,
			portalUserContext,
			itemNum,
			selectedFilter,
			startDate,
			endDate,
		};
		dispatch(getItemUnitOnHandInventory(params));
		dispatch(getItemRetailOnHandInventory(params));
	}, [
		weekFilter,
		category,
		selectedFilter,
		itemNum,
		startDate,
		endDate,
		selectedView,
	]);

	const data = {
		unit: itemUnitOnHandInventory,
		retail: itemRetailOnHandInventory,
	};

	return (
		<DrillDownTrend
			chartName={chartName}
			data={{ ...data }}
			loading={itemRetailOnHandInventory?.loading || false}
			category={category}
			weekFilter={weekFilter}
			selectedTab={selectedTab}
		/>
	);
}

ItemOnHandInventory.propTypes = {
	chartName: PropTypes.string,
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	category: PropTypes.string,
	selectedFilter: PropTypes.string,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	selectedTab: PropTypes.string,
	itemNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ItemOnHandInventory;
